import React from "react";
import Image from "next/image";
import { Loader2 } from "lucide-react";
import { cn } from "../../lib/utils";

interface LoadingScreenProps {
  isVisible: boolean;
  progress: number;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({
  isVisible,
  progress,
}) => {
  return (
    <div
      className={cn(
        "fixed inset-0 w-screen h-screen z-50 transition duration-700 ease-in-out bg-white/95 backdrop-blur-md flex items-center justify-center",
        isVisible
          ? "opacity-100 pointer-events-auto"
          : "opacity-0 pointer-events-none"
      )}
    >
      {/* Subtle Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-gray-50 via-white to-gray-50 opacity-60"></div>

      {/* Main Content */}
      <div className="relative z-10 flex flex-col items-center gap-8">
        {/* Logo */}
        <div className="relative w-48 h-48">
          <Image
            src="/caroffshore-logo.png"
            width={192}
            height={192}
            alt="car off shore logo"
            className="object-contain"
            priority
          />
        </div>

        {/* Spinner */}
        <Loader2 className="w-8 h-8 animate-spin text-black" />
      </div>
    </div>
  );
};
